import { ChangeDetectorRef, Component } from "@angular/core";
import * as moment from "jalali-moment";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { takeUntil } from "rxjs/operators";
import { Element } from "../../models/base-info/element.model";
import { PayCompaniesBranch } from "../../models/base-info/pay-companies-branch.model";
import { PayCompanies } from "../../models/base-info/pay-companies.model";
import { HRNotificationDetail, HRNotificationHeader } from "../../models/hrnotification-header.model";
@Component({
  selector: "ngx-hrnotification-header-form",
  templateUrl: "./hrnotification-header-form.component.html",
  styleUrls: ["./hrnotification-header-form.component.scss"],
})
export class HRNotificationHeaderFormComponent extends BaseFormComponent<HRNotificationHeader> {
  activeTabTitle: string = "شرح حکم";
  DetaileLedgerColumns: form_control[];
  erroremessage: string;
  _customDataList: PayCompaniesBranch[];
  HRNotificationDetails: form_control[];
  HrmPersonnelCompanyAssigns: form_control[];
  isLoading: boolean;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
    this.onRowSelected = this.onRowSelected.bind(this);
  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.DetaileLedgerColumns = undefined;
    this._customDataList = undefined;
    this.HRNotificationDetails = undefined;
    this.HrmPersonnelCompanyAssigns = undefined;
  }
  async ngOnInit() {
    this.defaultCoumnNumber = 6;
    this.setDetaileLedgerColumns();
    this.setPayCompaniesBranchs();
    this.apiName = "HRNotificationHeader";
    this.label = "حکم کارگزینی";
    super.ngOnInit();
    this.isNewRow = this.currentrow.State === RowState.New;
  }
  setColumnAttribute(): void {
    super.setColumnAttribute();
    this.HRNotificationDetails = this.getDetailControlModels("HRNotificationDetails");
    this.HrmPersonnelCompanyAssigns = this.getDetailControlModels("HrmPersonnelCompanyAssigns");
    this.orignalColumns.forEach((x) => {
      if (x.name === "EmploymentStartDate" && this.formGroup && this.formGroup.get(x.name)) {
        x.disabled = this.model.NotificationStatusKindCode > 1;
        if (x.disabled) this.formGroup.get(x.name).disable();
        else this.formGroup.get(x.name).enable();
        this.formGroup.get(x.name).updateValueAndValidity();
      }
    });
  }
  setdefault(): void {
    this.isNewRow = this.currentrow.State === RowState.New;
    if (this.isNewRow && !this.model.HrmPersonnelId && this.currentrow) Object.assign(this.model, this.currentrow);
    if (!this.model.IsGroupedIssue) {
      this.model.IsGroupedIssue = false;
      this.model.GroupedIssue = "انفرادی";
    }
    if (this.isNewRow) {
      this.model.Id = 0;
      if (this.model.HrmPersonnelCompanyAssigns) {
        this.model.HrmPersonnelCompanyAssigns.forEach((x) => {
          x.Id = 0;
          x.HRNotificationHeaderId = 0;
        });
      }
      if (this.model.HRNotificationDetails) {
        this.model.HRNotificationDetails.forEach((x) => {
          x.Id = 0;
          x.HRNotificationHeaderId = 0;
        });
      }
    }
    if (this.isNewRow === true) {
      this.model.IssueYear = this.accountService.authService.getHrmPayCurentYearMonth().CurentYear;
      this.setValue("IssueYear", this.model.IssueYear);
      this.model.EffectYear = this.accountService.authService.getHrmPayCurentYearMonth().CurentYear;
      this.setValue("EffectYear", this.model.EffectYear);
    }
    if (this.isNewRow === true) {
      this.model.IssueMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth;
      this.setValue("IssueMonth", this.model.IssueMonth);
      this.model.EffectMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth;
      this.setValue("EffectMonth", this.model.EffectMonth);
    }
    if (this.isNewRow === true) {
      this.model.IssueDay = 1;
      this.setValue("IssueDay", this.model.IssueDay);
      this.model.EffectDay = 1;
      this.setValue("EffectDay", this.model.EffectDay);
    }
    if (this.isNewRow === true) {
      this.model.IssueDate = new Date(
        moment
          .from(`${this.model.IssueYear}/${this.model.IssueMonth}/${this.model.IssueDay} 00:00`, "fa", "YYYY/MM/DD HH:mm")
          .format("YYYY-MM-DD HH:mm:ss")
      );
      this.setValue("IssueDate", this.model.IssueDate);
    }
    if (this.isNewRow === true) {
      this.model.EffectDate = new Date(
        moment
          .from(`${this.model.EffectYear}/${this.model.EffectMonth}/${this.model.EffectDay} 00:00`, "fa", "YYYY/MM/DD HH:mm")
          .format("YYYY-MM-DD HH:mm:ss")
      );
      this.setValue("EffectDate", this.model.EffectDate);
    }
    if (this.model) this.populateElement();
    this.httpCommonService
      .get<boolean>(`MonthlySalaryCalculationInformation/HasSalaryCalculation/${this.model.HrmPersonnelId}/${this.model.IssueYearMonth}`)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result) => {
        if (result === true && !this.isNewRow) {
          this.erroremessage = "به علت محاسبه حقوق حکم قابل ویرایش نیست.";
        }
      });
    this.setColumnAttribute();
  }
  isActveTab(title: string) {
    return this.activeTabTitle === title;
  }
  selectTab($event) {
    this.activeTabTitle = $event.tabTitle;
  }
  valueChanges($event) {}
  setDetaileLedgerColumns(): void {
    {
      this.DetaileLedgerColumns = [];
      this.DetaileLedgerColumns.push(<form_control>{
        label: "تفصیلی 1",
        controlType: FormControlTypes.lookup,
        modelName: "DetailLedger1Id",
        disabled: false,
        name: "DetailLedger1Id",
        order: 0,
        textType: "text",
        formVisible: true,
        listVisible: true,
        columnNumber: 1,
        userClass: "select-sm",
        required: false,
        apiName: "DetailLedger/GetPagining",
        valueMember: "Id",
        displayMember: "Title",
        columnsName: "Code,Title",
      });
      this.DetaileLedgerColumns.push(<form_control>{
        label: "تفصیلی 2",
        controlType: FormControlTypes.lookup,
        modelName: "DetailLedger2Id",
        disabled: false,
        name: "DetailLedger2Id",
        order: 1,
        textType: "text",
        formVisible: true,
        listVisible: true,
        columnNumber: 2,
        userClass: "select-sm",
        required: false,
        apiName: "DetailLedger/GetPagining",
        valueMember: "Id",
        displayMember: "Title",
        columnsName: "Code,Title",
      });
      this.DetaileLedgerColumns.push(<form_control>{
        label: "تفصیلی 3",
        controlType: FormControlTypes.lookup,
        modelName: "DetailLedger3Id",
        disabled: false,
        name: "DetailLedger3Id",
        order: 2,
        textType: "text",
        formVisible: true,
        listVisible: true,
        columnNumber: 3,
        userClass: "select-sm",
        required: false,
        apiName: "DetailLedger/GetPagining",
        valueMember: "Id",
        displayMember: "Title",
        columnsName: "Code,Title",
      });
      this.DetaileLedgerColumns.push(<form_control>{
        label: "تفصیلی 4",
        controlType: FormControlTypes.lookup,
        modelName: "DetailLedger4Id",
        disabled: false,
        name: "DetailLedger4Id",
        order: 3,
        textType: "text",
        formVisible: true,
        listVisible: true,
        columnNumber: 4,
        userClass: "select-sm",
        required: false,
        apiName: "DetailLedger/GetPagining",
        valueMember: "Id",
        displayMember: "Title",
        columnsName: "Code,Title",
      });
      this.DetaileLedgerColumns.push(<form_control>{
        label: "تفصیلی 5",
        controlType: FormControlTypes.lookup,
        modelName: "DetailLedger5Id",
        disabled: false,
        name: "DetailLedger5Id",
        order: 4,
        textType: "text",
        formVisible: true,
        listVisible: true,
        columnNumber: 1,
        userClass: "select-sm",
        required: false,
        apiName: "DetailLedger/GetPagining",
        valueMember: "Id",
        displayMember: "Title",
        columnsName: "Code,Title",
      });
      this.DetaileLedgerColumns.push(<form_control>{
        label: "تفصیلی 6",
        controlType: FormControlTypes.lookup,
        modelName: "DetailLedger6Id",
        disabled: false,
        name: "DetailLedger6Id",
        order: 5,
        textType: "text",
        formVisible: true,
        listVisible: true,
        columnNumber: 2,
        userClass: "select-sm",
        required: false,
        apiName: "DetailLedger/GetPagining",
        valueMember: "Id",
        displayMember: "Title",
        columnsName: "Code,Title",
      });
      this.DetaileLedgerColumns.push(<form_control>{
        label: "تفصیلی 7",
        controlType: FormControlTypes.lookup,
        modelName: "DetailLedger6Id",
        disabled: false,
        name: "DetailLedger7Id",
        order: 6,
        textType: "text",
        formVisible: true,
        listVisible: true,
        columnNumber: 3,
        userClass: "select-sm",
        required: false,
        apiName: "DetailLedger/GetPagining",
        valueMember: "Id",
        displayMember: "Title",
        columnsName: "Code,Title",
      });
    }
  }
  async onvalueChangeByApiName($event) {
    if ($event && $event.apiName && $event.data && $event.data.Id && $event.apiName.includes("EmploymentKind")) {
      this.model.EmploymentKindId = this.formGroup.get("EmploymentKindId").value;
      await this.populateElement();
    }
    if ($event && $event.apiName && $event.data && $event.data.Id && $event.apiName.includes("HRNotificationKind/GetPagining")) {
      this.model.NotificationStatusKindCode = $event.data.NotificationStatusKindCode;
      this.setValue("NotificationStatusKindCode", this.model.NotificationStatusKindCode);
      this.setColumnAttribute();
    }
  }
  async populateElement() {
    await this.httpCommonService
      .getList("HRNotificationHeader/GetActiveElement/" + this.model.EmploymentKindId + "/" + this.model.HrmPersonnelId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: Element[]) => {
          if (data) {
            let temp: HRNotificationDetail[] = [];
            Object.assign(temp, this.model.HRNotificationDetails);
            this.model.HRNotificationDetails = [];
            data.forEach((element) => {
              if (!this.model.HRNotificationDetails.some((e) => e.ElementId === element.Id)) {
                this.model.HRNotificationDetails.push({
                  Amount: temp.find((f) => f.ElementId === element.Id)?.Amount,
                  MonthAmount: temp.find((f) => f.ElementId === element.Id)?.MonthAmount,
                  DayAmount: temp.find((f) => f.ElementId === element.Id)?.DayAmount,
                  ElementId: element.Id,
                  ElementTitle: element.Title,
                  State: RowState.New,
                  HRNotificationHeaderId: this.model.Id,
                  Id: 0,
                  EffectDate: new Date(),
                });
              }
            });
          }
        },
        (error) => this.getFailedHelper(error)
      );

    await this.httpCommonService
      .getList("PayCompanies/ReadLookup")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data: PayCompanies[]) => {
          if (data) {
            if (!this.model.HrmPersonnelCompanyAssigns) this.model.HrmPersonnelCompanyAssigns = [];
            data.forEach((element) => {
              if (!this.model.HrmPersonnelCompanyAssigns.some((e) => e.PayCompaniesId === element.Id)) {
                this.model.HrmPersonnelCompanyAssigns.push({
                  PayCompaniesId: element.Id,
                  PayCompaniesTitle: element.Title,
                  State: RowState.New,
                  HRNotificationHeaderId: this.model.Id,
                  Id: 0,
                  Active4Calculation: false,
                  TaxGroupId: undefined,
                  InsueID: undefined,
                  PayCompaniesBranchTitle: undefined,
                  TaxGroupTitle: undefined,
                });
              }
            });
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }
  onRowSelected($event) {
    return this._customDataList.filter((x) => x.Id === $event["PayCompaniesId"]);
  }
  setPayCompaniesBranchs() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.httpCommonService
        .getList("PayCompanies/GetPayCompaniesBranchs")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (data: PayCompaniesBranch[]) => {
            if (data) {
              this.isLoading = false;
              this._customDataList = data;
            }
          },
          (error) => {
            this.isLoading = false;
            this.getFailedHelper(error);
          }
        );
    }
  }
}
